<div
	class="menu-profile-container"
	[ngClass]="{ 'profile-open': isProfileMenuOpen, 'profile-close': isProfileMenuOpen == false }"
	*ngIf="user">
	<div class="modal-header-container">
		<span class="back-button" *ngIf="profileMenuView !== 'profile'" (click)="profileMenuView = 'profile'"
			><fa-icon [icon]="icons['faArrowLeft']"></fa-icon
		></span>
		<span class="top-bar-image">{{ profileService.userData().firstNameLetters ?? '' }}</span>
		<span class="enduser-full-name">{{ user.fullName }}</span>
		<span class="close-modal-button" (click)="globalService.isProfileMenuOpen.set(false)"
			><fa-icon [icon]="icons['faTimes']"></fa-icon
		></span>
	</div>

	<div class="modal-body-container" *ngIf="profileMenuView === 'profile'">
		<div class="float-card">
			<div class="header-line">{{ labels.lbl_chamado_informacoes_gerais }}</div>
			<div class="dotted-input-container">
				<span>{{ labels.lbl_geral_email }}</span>
				<input
					type="email"
					[placeholder]="labels.lbl_geral_email"
					[value]="user.email"
					(input)="userCopy.email = $event.target.value"
					disabled />
			</div>
			<div class="dotted-input-container">
				<span>{{ labels.lbl_geral_telefone }}</span>
				<input
					type="text"
					[placeholder]="labels.lbl_geral_telefone"
					[value]="user.phone"
					(input)="userCopy.phone = $event.target.value"
					ui-br-phone-number-mask="areaCode" />
			</div>
			<div class="dotted-input-container">
				<span>{{ labels.lbl_geral_tel_celular }}</span>
				<input
					type="text"
					[placeholder]="labels.lbl_geral_tel_celular"
					[value]="user.mobile"
					(input)="userCopy.mobile = $event.target.value" />
			</div>
			<div class="dotted-input-container">
				<span>{{ labels.lbl_geral_localidade }}</span>
				<select (change)="notifyPageReload(); userCopy.locale = $event.target.value">
					<option *ngFor="let localeData of locale" [value]="localeData.ID" [selected]="localeData.ID === this.user.locale">
						(GMT{{ localeData.GMT >= '0' ? '+' + localeData.GMT + ':00' : localeData.GMT + ':00' }})
						{{ localeData.LOCALE }}
					</option>
				</select>
			</div>

			<div class="dotted-input-container">
				<span>{{ labels.lbl_clientes_disponiveis }}</span>
				<select (change)="notifyPageReload(); userCopy.idCustomer = $event.target.value">
					<option [value]="customer.id" [selected]="customer.id === user.idCustomer" *ngFor="let customer of availableCustomers">
						{{ customer.customer }}
					</option>
				</select>
			</div>
			<div class="dotted-input-container">
				<span>{{ labels.lbl_geral_idioma }}</span>
				<select (change)="notifyPageReload(); userCopy.language = $event.target.value">
					<option [value]="'Portuguese'" [selected]="this.user.language === 'Portuguese'">
						{{ labels.lbl_geral_portugues }}
					</option>
					<option [value]="'English'" [selected]="this.user.language === 'English'">
						{{ labels.lbl_geral_ingles }}
					</option>
					<option [value]="'Spanish'" [selected]="this.user.language === 'Spanish'">
						{{ labels.lbl_geral_espanhol }}
					</option>
					<option [value]="'Slovak'" [selected]="this.user.language === 'Slovak'">
						{{ labels.lbl_geral_eslovaco }}
					</option>
					<option [value]="'Chinese'" [selected]="this.user.language === 'Chinese'">
						{{ labels.lbl_geral_chines }}
					</option>
					<option [value]="'Italian'" [selected]="this.user.language === 'Italian'">
						{{ labels.lbl_geral_italiano }}
					</option>
				</select>
			</div>
			<div class="dotted-input-container">
				<span>{{ labels.lbl_geral_temas }}</span>
				<select
					id="themeProfile"
					(change)="notifyPageReload(); userCopy.css_pattern = $event.target.value; changeThemeExample($event.target.value)">
					<option
						[value]="style.id"
						[selected]="style.id === this.user.css_pattern"
						*ngFor="let style of profileService.styleSheetList">
						{{ style.name }}
					</option>
				</select>
			</div>
			<div class="dotted-input-container">
				<span>{{ labels.lbl_geral_temas }} - {{ labels.lbl_geral_exemplo }}</span>
				<span>
					<div class="theme-example-container">
						<ng-container *ngIf="!isLoadingTheme">
							<div class="button exempleThemeButton1">{{ labels.lbl_geral_exemplo }}</div>
							<div class="button exempleThemeButton2">{{ labels.lbl_geral_exemplo }}</div>
						</ng-container>
						<ng-container *ngIf="isLoadingTheme">
							<cpi-dot-bounce-loading-effect></cpi-dot-bounce-loading-effect>
						</ng-container>
					</div>
				</span>
			</div>
			<div class="dotted-input-container" *ngIf="this.user.enduser_active || this.user.analyst_active">
				<span>{{ labels.lbl_geral_perfil }}</span>
				<select (change)="notifyPageReload(); userCopy.sessionStatus = $event.target.value">
					<option [value]="'0'" *ngIf="this.user.enduser_active" [selected]="!isAnalystView">
						{{ labels.lbl_chamado_enduser }}
					</option>
					<option [value]="'1'" *ngIf="this.user.analyst_active" [selected]="isAnalystView">
						{{ labels.lbl_geral_analista }}
					</option>
				</select>
			</div>
			<div class="dotted-input-container" *ngIf="this.user.enduser_active || this.user.analyst_active">
				<span
					>{{ labels.lbl_receber_log_chamados_email }}
					<fa-icon [icon]="icons['faInfoCircle']" [title]="labels.lbl_opcao_aplicada_ambos_perfis"></fa-icon
				></span>
				<cpi-checkbox
					[value]="this.receiveEmailLog"
					(oValue)="this.receiveEmailLog = $event"
					[innerText]="this.receiveEmailLog ? labels.lbl_geral_sim : labels.lbl_geral_nao">
				</cpi-checkbox>
			</div>
			<div class="dotted-input-container" *ngIf="this.user.sessionStatus.toString() == '1'">
				<span
					>{{ labels.lbl_visualizar_chamados_aguardando_autorizacao }}
					<fa-icon [icon]="icons['faInfoCircle']" [title]="labels.lbl_explicacao_visualizar_ambos_chamados"></fa-icon
				></span>
				<cpi-checkbox
					[value]="showAwaitingAuthorization"
					(oValue)="
						showAwaitingAuthorization = $event;
						showAwaitingAuthorization != awaitingAuthorizationMemory ? notifyPageReload() : null
					"
					[innerText]="showAwaitingAuthorization ? labels.lbl_geral_sim : labels.lbl_geral_nao">
				</cpi-checkbox>
			</div>
		</div>

		<div
			class="float-card"
			*ngIf="profileService.userData().sourceIdBehalfOf == undefined && permissionService.hasPermission('allowBehalfOf')">
			<div class="header-line">{{ labels.lbl_visualizacao_perfil_remoto }}</div>

			<cpi-generic-form-gen [setGenericForm]="behalfOfForm" [labels]="labels"> </cpi-generic-form-gen>

			<div class="button-container">
				<div
					class="button"
					(click)="getAllowedBehalfOfUsers(behalfOfForm[0].values[0], behalfOfForm[1].values[0], behalfOfForm[2].values[0])">
					<span>{{ labels.lbl_geral_pesquisar }}</span>
					<cpi-dot-bounce-loading-effect [color]="'var(--const-white)'" *ngIf="isLoadingBehalfOf">
					</cpi-dot-bounce-loading-effect>
				</div>
			</div>

			<cpi-input-with-autocomplete
				[availableOptions]="allowedBehalfOfUsersIAC"
				[placeholder]="labels.lbl_buscar_usuarios + ' (' + labels.lbl_iac_min_char_search.replace('$__$', '3') + ')'"
				[minInputLength]="3"
				[inputHeight]="'30px'"
				[setInputText]="selectedBehalfOfUser.fullName !== undefined ? searchInputText : selectedBehalfOfUser.fullName"
				(onValueChange)="selectedBehalfOfUser.email = $event"
				*ngIf="!isLoadingBehalfOf && allowedBehalfOfUsers.length > 0">
			</cpi-input-with-autocomplete>

			<div class="button-container">
				<div
					class="button"
					[ngClass]="{
						disabled:
							isEnteringBehalfOfMode || isLoadingBehalfOf || !selectedBehalfOfUser.email || selectedBehalfOfUser.email === '',
					}"
					(click)="enterBehalfOfMode()">
					{{ labels.lbl_ativar_visao_usuario }}
					<cpi-dot-bounce-loading-effect [color]="'var(--const-white)'" *ngIf="isEnteringBehalfOfMode">
					</cpi-dot-bounce-loading-effect>
				</div>
			</div>
		</div>
		<div class="float-card" *ngIf="profileService.userData().sourceIdBehalfOf != undefined">
			<div class="header-line">{{ labels.lbl_visualizacao_perfil_remoto }}</div>
			<div class="button-container">
				<div class="button" [ngClass]="{ disabled: isEnteringBehalfOfMode }" (click)="leaveBehalfOfMode()">
					{{ labels.lbl_retornar_perfil }}
					<cpi-dot-bounce-loading-effect [color]="'var(--const-white)'" *ngIf="isEnteringBehalfOfMode">
					</cpi-dot-bounce-loading-effect>
				</div>
			</div>
		</div>

		<div class="float-card">
			<div class="header-line">{{ labels.lbl_ausencia_temporaria }}</div>
			<div class="button-container">
				<div class="button" (click)="profileMenuView = 'outOfOffice'">{{ labels.lbl_security_agendar }}</div>
			</div>
		</div>

		<div class="float-card" *ngIf="isAnalystView">
			<div class="header-line">{{ labels.lbl_geral_comunicacao }}</div>

			<div class="comunication-line" *ngFor="let contact of user.contacts; let index = index">
				<span>
					<select (change)="userCopy.contacts[index].contact_type = $event.target.value">
						<option value="WPP" [selected]="user.contacts[index].contact_type === 'WPP'">WhatsApp</option>
						<option value="TEAMS" [selected]="user.contacts[index].contact_type === 'TEAMS'">Teams</option>
						<option value="EMAIL" [selected]="user.contacts[index].contact_type === 'EMAIL'">
							{{ labels.lbl_geral_email }}
						</option>
					</select>
				</span>
				<span>
					<input
						type="text"
						[value]="user.contacts[index].contact_value"
						(input)="userCopy.contacts[index].contact_value = $event.target.value" />
					<span class="icon" (click)="removeEnduserContact(index)"><fa-icon [icon]="icons['faTrash']"></fa-icon></span>
				</span>
			</div>

			<div class="comunication-line">
				<span class="icon" (click)="addEnduserContact()">{{ labels.lbl_geral_adicionar_novo }}</span>
			</div>
		</div>

		<div class="float-card">
			<div class="header-line">{{ labels.lbl_geral_opcoes_extra }}:</div>

			<div class="dotted-input-container">
				<span>{{ labels.lbl_formato_preferido_de_datas }}</span>
				<select (change)="userDateFormat = $event.target.value; saveDateFormat($event.target.value)">
					<!-- <option value="YMD" [selected]="userDateFormat == 'YMD'">{{labels.lbl_formato_data_aaaa_mm_dd}}</option>
                    <option value="DMY" [selected]="userDateFormat == 'DMY'">{{labels.lbl_formato_data_dd_mm_aaaa}}</option>
                    <option value="MDY" [selected]="userDateFormat == 'MDY'">{{labels.lbl_formato_data_mm_dd_aaaa}}</option> -->
					<option value="YMD HMS" [selected]="userDateFormat === 'YMD HMS'">
						{{ labels.lbl_formato_data_aaaa_mm_dd_hh_mm }}
					</option>
					<option value="DMY HMS" [selected]="userDateFormat === 'DMY HMS'">
						{{ labels.lbl_formato_data_dd_mm_aaaa_hh_mm }}
					</option>
					<option value="MDY HMS" [selected]="userDateFormat === 'MDY HMS'">
						{{ labels.lbl_formato_data_mm_dd_aaaa_hh_mm }}
					</option>
				</select>
			</div>

			<div class="dotted-input-container">
				<span>{{ labels.lbl_geral_modo_escuro }}</span>
				<cpi-checkbox
					[forceText]="false"
					[value]="darkModeOn"
					(oValue)="globalService.darkModeOn.next($event)"
					[innerText]="darkModeOn === true ? labels.lbl_geral_ativado : labels.lbl_geral_desativado">
				</cpi-checkbox>
			</div>

			<app-menu-lateral-options [labels]="labels"></app-menu-lateral-options>

			@if (permissionService.hasPermission('access_request')) {
				<div class="dotted-input-container">
					<div>
						<span>Atualizar chamados periodicamente</span>
						<span><fa-icon [icon]="icons.faQuestionCircle"></fa-icon></span>
					</div>
					<cpi-checkbox
						[forceText]="false"
						[value]="profileSignal.requestUpdateIntervalOn()"
						(oValue)="
							profileSignal.setStorage('requestUpdateIntervalOn', $event === 1);
							profileSignal.requestUpdateIntervalOn.set($event === 1)
						"
						[innerText]="
							profileSignal.requestUpdateIntervalOn() === true ? labels.lbl_geral_ativado : labels.lbl_geral_desativado
						">
					</cpi-checkbox>
				</div>
			}
		</div>

		<div class="button-container vertical">
			<div class="button primary-1" (click)="profileMenuView = 'passwordReset'">{{ labels.lbl_mudar_senha }}</div>
		</div>
	</div>

	<div class="button-container center" *ngIf="profileMenuView === 'profile'">
		<!-- <div class="button primary-2" (click)="profileMenuView = 'passwordReset'">{{labels.lbl_mudar_senha}}</div> -->
		<div class="button primary" [ngClass]="{ disabled: isLoadingSubmit }" (click)="updateEnduserData()">
			{{ labels.lbl_geral_submeter }}
			<ng-container *ngIf="isLoadingSubmit"
				>&nbsp;
				<cpi-dot-bounce-loading-effect [color]="'var(--const-white)'"></cpi-dot-bounce-loading-effect>
			</ng-container>
		</div>
	</div>

	<div class="modal-body-container" *ngIf="profileMenuView === 'passwordReset'">
		<pcp-password-reset [email]="user.email"></pcp-password-reset>
	</div>
	<div class="modal-body-container" *ngIf="profileMenuView === 'outOfOffice'">
		<pcp-out-of-office></pcp-out-of-office>
	</div>
</div>
